<div class="d-flex flex-column align-content-between justify-content-between h-100">
    <app-header></app-header>
    <div>
        <ng-content></ng-content>
    </div>
    <app-footer></app-footer>
</div>

